<template>
  <div class="fangQ">
    <topNav :title="$t('fangQ_title')"></topNav>
    <div class="ssearch">
      <switchbtn checked='swith'
                 size="small"
                 @change="switchChange"
                 :title1="$t('fangQ_title1')"
                 :title2="$t('fangQ_title2')"></switchbtn>
      <div class="go-btn" v-if="showList" @click="goList">列表.</div>
    </div>

    <div id="fangQchart">

    </div>

    <div class="formTop">
      <!--  日期-->
      <div class="topOne"
           style="width:20%">{{$t('fangQ_date')}}
      </div>

      <template v-if="showType == 1">
        <!--  均价-->
        <div class="topOne"
             style="width:20%">{{$t('fangQ_average_price')}}
        </div>
        <!--  出租率-->
        <div class="topOne"
             style="width:20%">{{$t('fangQ_rents')}}
        </div>
        <!--  RevPAR-->
        <div class="topOne"
             style="width:20%">RevPAR
        </div>
      </template>
      <template v-if="showType == 2">
        <!--  可用-->
        <div class="topOne"
             style="width:20%">{{$t('fangQ_available')}}
        </div>
        <!--  占用-->
        <div class="topOne"
             style="width:20%">{{$t('fangQ_takeup')}}
        </div>
        <!--  维修-->
        <div class="topOne"
             style="width:20%">{{$t('fangQ_maintenance')}}
        </div>
      </template>
      <!--  操作-->
      <div class="topOne"
           style="width:20%"> {{$t('fangQ_action')}}
      </div>
    </div>
    <ul v-infinite-scroll="loadMore"
        infinite-scroll-disabled="loading"
        infinite-scroll-distance="10"
        class="ind">
      <table class="conditionList"
             align='center'
             style="border-collapse:collapse;">
        <tbody class="tbodyH">
        <tr v-for='(item,key) in condition_list'
            :key="key"
            width="80px"
            @click='goDetail(item)'
            :class='{firday:new Date(item.date).getDay()==5,sta:new Date(item.date).getDay()==6}'>
          <td width="20%">
            <p>{{item.date.replace(/-/g, '/').substring(5)}}</p>
            <p>{{item.date | week}}</p>
          </td>

          <template v-if="showType == 1">
            <td width="20%">
              {{item.avg}}
            </td>
            <td width="20%">
              {{item.rate}}
            </td>
            <td width="20%">
              {{item.RevPAR}}
            </td>
          </template>

          <template v-if="showType == 2">

            <td width="20%">
              {{item.inLive}}
            </td>
            <td width="20%">
              {{item.inReservation}}
            </td>
            <td width="20%">
              {{item.inRemain}}
            </td>
          </template>

          <td width="20%">
            {{$t('fangQ_detail')}}
          </td>

        </tr>
        </tbody>
      </table>
    </ul>
  </div>
</template>

<script>
import moment from "moment";
import json from "../../conf/datePick.js";
import {Toast, InfiniteScroll} from "mint-ui";
import _ from "lodash";
import switchbtn from "../common/switch";
import echarts from "echarts";

export default {
  data() {
    return {
      condition_list: [],
      loading: false,
      step: 14,
      time: '',
      swith: false,
      showType: 1,
      chartArr: [],
      showList: localStorage.getItem('showFangQList') == 'yes'
    };
  },
  mounted() {
    this.getBizDate()
    // this.getData();
    //监听该页面滚动条
  },
  methods: {
    goBack(){
      this.$router.go(-1);
    },
    switchChange(value) {
      this.showType = value ? 1 : 2;
      this.drawChart()
    },

    loadMore() {
      if (!this.loading) {
        if(this.time){
          this.time = moment(this.time).add(this.step, "d");
          this.getData();
        }
      }
    },
    goList(){
      this.$router.push('/fangQList')
    },
    getBizDate() {
      this.$http
        .post("/mobilepmsapi/reception/getBizDate", {
          noErrorToast: true
        })
        .then(res => {
          if (res.data.result == 0) {
            this.time = moment(res.data.retVal || '').format("YYYY-MM-DD")
          } else {
            this.time = moment().format("YYYY-MM-DD")
          }

          this.getData()
        }).catch(action => {
          this.time = moment().format("YYYY-MM-DD")
          this.getData()
        });
    },
    getData() {
      this.loading = true;
      this.$http
        .post("/mobilepmsapi/reception/getRoomSituation", {
          d: this.time,
          step: this.step
        })
        .then(res => {
          if (res.data.result == 0) {
            if (res.data.retVal.length > 0) {
              this.loading = false;
            }
            _.forEach(res.data.retVal, (n1, key1) => {
              n1.RevPAR = this.getRevPAR(n1)
              this.condition_list.push(n1);
            });

            this.drawChart();
          } else {
            this.msg(res.data.msg);
          }
        });
    },

    drawChart() {
      this.chartArr = this.condition_list || []
      var cData = []
      this.chartArr.map((item, index) => {
        cData.push(item.date.replace(/-/g, '/').substring(5))
      })
      // x轴数据
      var myChart = echarts.init(document.getElementById("fangQchart", "customed"));
      let series = []
      let yAxis = []
      let tooltip = {}
      let legend = {
        data: []
      }
      if (this.showType == 1) {
        let avgData = _.map(this.chartArr, 'avg')
        let rateData = this.chartArr.map((item, index) => {
          return Number(item.rate.substr(0, item.rate.length - 1) || '')
        })
        let RevParData = _.map(this.chartArr, 'RevPAR')
        legend = {
          data: [this.$t("fangQ_average_price"), this.$t("fangQ_rents"), 'RevPAR']
        }
        tooltip = {
          trigger: "axis",
          formatter: function (params) {	//根据条件修改
            var relVal = params[0].name;
            for (var i = 0; i < params.length; i++) {
              let unit = i == 1 ? '%' : '';
              relVal += '<div class="circle" ><span style="background:' + params[i].color + '"></span>' + params[i].seriesName + ' : ' + params[i].value + unit + "</div>";
            }
            return relVal;
          }
        }
        yAxis = [{
          type: 'value',
          scale: true,
          name: this.$t("fangQ_average_price") + ', RevPAR',
        }, {
          type: 'value',
          scale: true,
          name: this.$t("fangQ_rents"),
          axisLabel: {
            formatter: '{value}%'
          },
        }]
        series = [{
          type: "line",
          name: this.$t("fangQ_average_price"),
          data: avgData,
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
        }, {
          type: "line",
          name: this.$t("fangQ_rents"),
          yAxisIndex: 1,
          data: rateData,
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
        }, {
          type: "line",
          name: 'RevPAR',
          data: RevParData,
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
        }]
      } else {
        let inLiveData = _.map(this.chartArr, 'inLive')
        let inReservationData = _.map(this.chartArr, 'inReservation')
        let inRemainData = _.map(this.chartArr, 'inRemain')
        tooltip = {
          trigger: "axis",
        }
        yAxis = {
          type: "value",
          axisTick: {
            inside: true
          },
          axisLabel: {
            inside: true,
          }
        }
        legend = {
          data: [this.$t("fangQ_available"), this.$t('fangQ_takeup'), this.$t('fangQ_maintenance')]
        }
        series = [{
          type: "line",
          name: this.$t("fangQ_available"),
          data: inLiveData,
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
        }, {
          type: "line",
          name: this.$t('fangQ_takeup'),
          data: inReservationData,
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
        }, {
          type: "line",
          name: this.$t('fangQ_maintenance'),
          data: inRemainData,
          smooth: true,
          symbol: "circle",
          symbolSize: 5,
        }]
      }

      var option = {
        legend: legend,
        grid: {
          left: "4%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        tooltip: tooltip,
        dataZoom: [{
          type: "inside"
        }, {
          handleIcon: "M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z",
          handleSize: "80%",
          handleStyle: {
            color: "#fff",
            shadowBlur: 3,
            shadowColor: "rgba(0, 0, 0, 0.6)",
            shadowOffsetX: 2,
            shadowOffsetY: 2
          }
        }],
        xAxis: {
          type: "category",
          data: cData,
          // axisLabel : {//坐标轴刻度标签的相关设置。
          //   interval: 1,
          // }
        },
        yAxis: yAxis,
        series: series,
      };
      myChart.setOption(option, true);
    },

    msg(msg) {
      Toast({
        message: msg,
        position: "bottom",
        duration: 3000
      });
    },
    dateChange(time) {
      this.getData(time);
    },
    goDetail(item) {
      this.$router.push({
        path: "fangXQ",
        query: {
          date: item.date
        }
      });
    },

    getRevPAR(item) {
      let avg = item.avg || ''
      let rate = item.rate || ''
      if (avg == 0) {
        return 0
      }
      if (!avg || !rate) {
        return '-'
      } else {
        let rateNum = Number(rate.substr(0, rate.length - 1) || '')
        return parseFloat(avg * rateNum / 100).toFixed(2);
      }
    }
  },
  filters: {
    week(value) {
      return moment(value).day() == 0
        ? json.week[json.week.length - 1]
        : json.week[moment(value).day() - 1];
    },

  },
  components: {
    switchbtn
  }
};
</script>

<style lang="less">
.fangQ {
  overflow: auto;

  .ssearch {
    margin: 0.2667rem auto;
    position: relative;
    .go-btn {
      position: absolute;
      top: 5px;
      right: 0;
      display: inline-block;
      background: orange;
      color: #fff;
      border-radius: 30px 0 0 30px;
      box-sizing: border-box;
      padding:5px;
      padding-left: 10px;
    }

    .mianBox {
      margin: 0 auto;
      width: 150px !important;
      height: 35px;
      position: relative;
    }

    .leftBox,
    .rightBox {
      width: 90px !important;
    }

    .rightBox {
      left: 70px !important;
    }
  }

  #fangQchart {
    width: 100%;
    margin: 0 auto;
    padding: 0;
    height: 232px;
    box-sizing: border-box;
  }

  .formTop {
    width: 100%;
    clear: both;
    position: fixed;
    z-index: 0;

    .topOne {
      height: 1.06666667rem;
      color: #fff;
      background-color: #f69c2d;
      text-align: center;
      line-height: 1.0133rem;
      float: left;
      font-size: 0.34666667rem;
      font-weight: bold;
      padding: 0;
    }
  }

  .formTopFix {
    position: fixed;
    top: 1.04rem;
    z-index: 200;
  }

  .ind {
    overflow-y: scroll;
    position: absolute;
    top: 365px + 1.04rem;
    bottom: 0;
    width: 100%;
    -webkit-overflow-scrolling: touch;
  }

  .conditionList {
    width: 100%;

    .firday {
      background: #f6ef8b !important;
    }

    .sta {
      background: #f8e81c !important;
    }

    tr {
      background-color: #fff;

      &:nth-of-type(2n) {
        background-color: #f5f5f5;
      }

      font-size: 0.32rem;

      th {
        color: #fff;
        // height: 1.06666667rem;
        text-align: center;
        font-size: 0.34666667rem;
        background-color: #f69c2c;
        padding: 0;
      }

      td {
        height: 1.56666667rem;
        padding: 0px;
        text-align: center;

        p {
          margin: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// fangQ.vue?4d8fab01